/*eslint-disable*/
import React from 'react';
import PropTypes from 'prop-types';
import { lowerCase, upperFirst } from 'lodash';

const PrivateContext = React.createContext();

const DEFAULT_LABEL = 'Admin Panel';

export const useModuleContext = () => React.useContext(PrivateContext);

export const ModuleRoute = ({ title, component: Component }) => {
  const { setActiveModule } = useModuleContext();
  React.useEffect(() => {
    setActiveModule(title);
    return () => {
      setActiveModule(DEFAULT_LABEL);
    };
  }, [title, setActiveModule]);
  return <Component />;
};

ModuleRoute.defaultProps = {
  children: null,
};

ModuleRoute.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.instanceOf(Object),
};

export const ModuleLabel = () => {
  const { activeModule, subLabel } = useModuleContext();
  return (
    <div className="mb-5 flex-initial">
      {/*
        Sentence case, not the old lodash upperCase(). Route titles are mixed
        case in the array ('subscriptions', 'Banned Words', 'Roles And
        Permissions'), so normalise rather than render them raw.
      */}
      <h1 className="text-2xl font-bold tracking-[-.015em] text-neutral-900">
        {upperFirst(lowerCase(activeModule))}
      </h1>
      {subLabel && (
        <p className="mt-1 text-sm font-medium text-neutral-500">{subLabel}</p>
      )}
    </div>
  );
};

function ModuleWrapper({ children }) {
  const [activeModule, setActiveModule] = React.useState(DEFAULT_LABEL);
  const [subLabel, setSubLabel] = React.useState('');
  return (
    <PrivateContext.Provider
      value={{ activeModule, setActiveModule, subLabel, setSubLabel }}
    >
      {children}
    </PrivateContext.Provider>
  );
}

ModuleWrapper.propTypes = {
  children: PropTypes.instanceOf(Object).isRequired,
};

export default ModuleWrapper;
